import React from 'react';
import { usePatchElement } from './usePatchElement';
import { InternalConfirm } from '../InternalConfirm';
import { randomStr } from '../../../Shared/random';
import { destroyFns } from '../destroy';
let hookTime = 0;
const keyPrefix = randomStr();
const createKey = () => {
    hookTime += 1;
    return `Dialog-${keyPrefix}-${hookTime}`;
};
const ElementsHolder = React.memo(React.forwardRef((_props, ref) => {
    const [elements, patchElement, clearElements] = usePatchElement();
    React.useImperativeHandle(ref, () => ({
        patchElement,
        clearElements,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, elements);
}));
export function useDialog() {
    const holderRef = React.useRef(null);
    const hookKey = React.useRef(`dialog-hook-holder-${randomStr()}`);
    const getConfirmFunc = React.useCallback((opts) => {
        const hookHandlerRef = React.createRef();
        const hookDialog = (React.createElement(InternalConfirm, { ...opts, key: createKey(), handlerRef: hookHandlerRef }));
        const destroyFunc = holderRef.current?.patchElement(hookDialog);
        // istanbul ignore else
        if (destroyFunc) {
            destroyFns.push(destroyFunc);
        }
        return {
            open: () => {
                hookHandlerRef.current?.open();
            },
            close: () => {
                hookHandlerRef.current?.close();
            },
            update: (updatedOpts) => {
                hookHandlerRef.current?.update?.(updatedOpts);
            },
            destroy: () => {
                destroyFunc?.();
            },
        };
    }, []);
    const getDestroyFunc = React.useCallback(() => {
        holderRef.current?.clearElements();
    }, []);
    const hookAPI = React.useMemo(() => ({
        confirm: getConfirmFunc,
        // The destroyAll here can only destroy the Dialog created by Hook
        destroyAll: getDestroyFunc,
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return [hookAPI, React.createElement(ElementsHolder, { key: hookKey.current, ref: holderRef })];
}
